import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class LoginService {
    constructor(private httpClient: HttpClient) { }

    login(username: String, password: String) {
        let logData = "grant_type=password&username=" + username + "&password=" + password;
        return this.httpClient.post('api/token?' + logData, logData);
    }
}